module.exports = __webpack_public_path__ + "img/p8.69cfaf0a.png";